export default __webpack_public_path__ + "static/media/140.bc18be94.png";